import { bindActionCreators } from "redux";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { logout } from "../../actions/authActions";
import hcIcon from "../../assets/logo-brand-gold.png";
import logo from "../../assets/logo-black-horizontal.png";
import styled from "styled-components";
import { NavWrapper, NavBar, HeaderText, MainHeader } from "./Header.styles";
import "./header-style.css";

const Anchor = styled.a`
  font-weight: bold;
  letter-spacing: 1px;
  color: #0b233f;
  margin: 0 12px;
  text-transform: uppercase;
  font-size: 12px;

  & i {
    font-size: 14px;
  }
`;

const displayMobileMenu = () => {
  var x = document.getElementById("mobile-menu");
  if (x.className === "mobile-header-content") {
    x.className += " show-menu";
  } else {
    x.className = "mobile-header-content";
  }
};

class Header extends React.Component {
  doLogout = (e) => {
    e.preventDefault();
    this.props.logout();
  };

  actionItems() {
    return (
      <React.Fragment>
        <Anchor
          href="https://app.codesignal.com/get-certified?invite=4eRfdndoCr3GFtToF"
          target="_blank"
        >
          <i style={{ fontWeight: "bold" }} className="fa fa-code"></i> Practice
        </Anchor>

        {this.props.user["15MinCalendly"] ? (
          <Anchor href={this.props.user["15MinCalendly"][0]} target="_blank">
            <i className="fa fa-calendar-check-o"></i> Schedule
          </Anchor>
        ) : null}

        <Anchor
          onClick={(e) => {
            e.preventDefault();
            this.doLogout(e);
          }}
          href=""
        >
          <i className="fa fa-power-off"></i> Logout
        </Anchor>
      </React.Fragment>
    );
  }

  render() {
    const authenticated = !!this.props.user;
    if (authenticated && this.props.user.name === undefined) {
      this.props.user.name = `${this.props.user.first_name} ${this.props.user.last_name}`;
    }

    return (
      <NavWrapper>
        <NavBar className="container navbar">
          <MainHeader>
            <Link to={"/"} style={{ padding: "15px 0px" }}>
              <img src={logo} alt="Human.Capital Logo" />
            </Link>
            {authenticated ? (
              <div className="header-content" id="top-nav">
                <HeaderText>Welcome, {this.props.user.name}</HeaderText>
                {this.actionItems()}
                <a
                  href=""
                  className="mobile-menu"
                  onClick={(e) => {
                    e.preventDefault();
                    displayMobileMenu();
                  }}
                >
                  <i className="fa fa-bars"></i>
                </a>
              </div>
            ) : null}
          </MainHeader>
        </NavBar>
        <div className="mobile-header">
          <div className="mobile-header-main">
            {authenticated ? (
              <React.Fragment>
                <Link to={"/"}>
                  <img height={24} src={hcIcon} alt="Human.Capital Logo" />
                </Link>

                <HeaderText style={{ color: "#142844" }}>
                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>{" "}
                  {this.props.user.name}
                </HeaderText>
                <a
                  href=""
                  className="mobile-menu"
                  onClick={(e) => {
                    e.preventDefault();
                    displayMobileMenu();
                  }}
                >
                  <i className="fa fa-bars"></i>
                </a>
              </React.Fragment>
            ) : (
              <Link style={{ margin: "0px auto" }} to={"/"}>
                <img src={logo} alt="Human.Capital Logo" />
              </Link>
            )}
          </div>
          {authenticated ? (
            <div className="mobile-header-content" id="mobile-menu">
              {this.actionItems()}
            </div>
          ) : null}
        </div>
      </NavWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: logout,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/header/Header.js